import React from 'react';
import {Room as Room} from "../lib/stores/RoomStore";
import {ListItem, ListItemAvatar, ListItemText, Typography} from "@mui/material";
import Avatar from "../Common/Avatar";
import {createInviteLink} from "../lib/utils";
import Pets from "@mui/icons-material/Pets";
import shadowClient from "../lib/clients/shadow/shadowClient";

const RoomItem = ({room}: { room: Room }) => {

    const message = room.lastMessage;
    const maxMessageLength = 70;
    const messageContent = message?.content;
    const isCutoff = messageContent && messageContent.length > maxMessageLength;

    let formattedMessage = "";
    if (messageContent) {
        formattedMessage = " — " + messageContent.slice(0, maxMessageLength);

        if (isCutoff) {
            formattedMessage += "...";
        }
    }
    const ownerId = room['owner_id'];
    const clientUser = shadowClient.getClientUser();
    const isOwner = clientUser && ownerId === clientUser.id;

    return <ListItem alignItems="flex-start">
        <ListItemAvatar>
            <Avatar user={message?.author}/>
        </ListItemAvatar>
        <ListItemText
                sx={{
                    cursor: "pointer",
                    wordBreak: "break-word",
                }}
                onClick={async () => {
                    window.location.href = createInviteLink(room, shadowClient.getQueryToken());
                }}
                primaryTypographyProps={{
                    display: "flex",
                    alignItems: "center",
                }}
                primary={<> {room.name} {isOwner && <Pets sx={{fontSize: "12px", marginLeft: "4px"}}/>}</>}
                secondary={
                    <React.Fragment>
                        <Typography
                                sx={{display: 'inline'}}
                                component="span"
                                variant="body2"
                                color="text.primary"
                        >
                            {message ? `${message.author.display_name || message.author.username}` : 'No message'}
                        </Typography>
                        {message && formattedMessage}
                        <Typography
                                sx={{
                                    display: 'flex',
                                    alignItems: "center",
                                    fontWeight: "bold",
                                    opacity: "0.4",
                                }}
                                component="span"
                                variant={"caption"}
                                color="text.primary"
                        >
                            {room.user_count + " users"}
                        </Typography>
                    </React.Fragment>
                }
        />
    </ListItem>
};

export default RoomItem;
